module.exports = __webpack_public_path__ + "img/foot_qr_ihec.1a0c28dc.png";